import { Map } from 'immutable';

import * as types from './types';
import { TestRecord, TestCaseRecord } from './../../records';

const initialState = new Map({
  pagination: new Map({
    size: 10,
    activePage: 0,
  }),
  testCases: new Map(),
});

const testListReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.CHANGE_PAGINATION:
      return state.set('pagination', payload || initialState.get('pagination'));
    case types.GET_TEST_CASE.SUCCESS: {
      const items = payload.items.map((test) => (
        new TestRecord({ ...test })
      ));
      return state.setIn(['testCases', payload.name], new TestCaseRecord({ ...payload, last_passes: items }));
    }
    default:
      return state;
  }
};

export default testListReducer;
export { initialState };
